document.addEventListener('DOMContentLoaded', function() {
    const morse_converter =  {
        'a': '.- ',
        'b': '-... ',
        'c': '-.-. ',
        'd': '-.. ',
        'e': '. ',
        'f': '..-. ',
        'g': '--. ',
        'h': '.... ',
        'i': '.. ',
        'j': '.--- ',
        'k': '-.- ',
        'l': '.-.. ',
        'm': '-- ',
        'n': '-. ',
        'o': '--- ',
        'p': '.--. ',
        'q': '--.- ',
        'r': '.-. ',
        's': '... ',
        't': '- ',
        'u': '..- ',
        'v': '...- ',
        'w': '.-- ',
        'x': '-..- ',
        'y': '-.-- ',
        'z': '--.. ',
        '1': '.---- ',
        '2': '..--- ',
        '3': '...-- ',
        '4': '....- ',
        '5': '..... ',
        '6': '-.... ',
        '7': '--... ',
        '8': '---.. ',
        '9': '----. ',
        '0': '----- ',
        '.': '.-.-.- ',
        ',': '--..-- ',
        '?': '..--.. ',
        "'": '.----. ',
        '!': '-.-.-- ',
        '/': '-..-. ',
        '(': '-.--. ',
        ')': '-.--.- ',
        '&': '.-... ',
        ':': '---... ',
        ';': '-.-.-. ',
        '=': '-...- ',
        '+': '.-.-. ',
        '-': '-....- ',
        '_': '..--.- ',
        '"': '.-..-. ',
        '$': '...-..- ',
        '@': '.--.-. ',
        ' ': '/'
      }
    let windowUrl = window.location.href;
    let engravingType = null;
    let engravingText = null;
    let engravingFont = null;
    let parentVariantId = null;
    const variantPopup = document.querySelector('.variant-popup-customization');
    const popupButton = document.querySelector('.product-popup-button-wrapper button');
    const closeBtn = document.querySelector('.variant-popup-header .close-btn');
    const goBackBtn = document.querySelector('.variant-popup-header .go-back-btn');
    const rotatingCopy = ["our initials (JFK)","The date you met (03.03.2003)","Children\'s names (Sarah)","Your nickname for each other (Peanut)","My ♡ is yours","You complete me"];
    const rotatingCopySelector = document.querySelector('.popular-engravings span');
    const morseCodeInput = document.querySelector('#morse-code-engraving-input');
    const morseCodeTranslation = document.querySelector('#morse-code-translation');
    let currentIndex = 0;
    morseCodeInput.addEventListener('keyup', function() {
        const value = morseCodeInput.value;
        let output = '';
        for (var i = 0; i < value.length; i++) {
            output += morse_converter[value.charAt(i).toLowerCase()];
        }
        morseCodeTranslation.value = output;
    });
    function handleRotatingCopy(){
        rotatingCopySelector.textContent = rotatingCopy[currentIndex];
        currentIndex++;
        if(currentIndex >= rotatingCopy.length){
            currentIndex = 0;
        }
        const currentCopy = rotatingCopy[currentIndex];
        rotatingCopySelector.textContent = currentCopy;
        setTimeout(handleRotatingCopy, 2000);
    }
    popupButton.addEventListener('click', function() {
        variantPopup.classList.add('active');
        document.body.style.overflow = 'hidden';
        handleRotatingCopy();
        const elementHtml = document.querySelector('.gpo-container');
        console.log("elementHtml", elementHtml);
        const targetElement = document.querySelector('.engraving-input-container-file');
        targetElement.appendChild(elementHtml);
    });
    closeBtn.addEventListener('click', function() {
        variantPopup.classList.remove('active');
        document.body.style.overflow = 'unset';
        removeActiveClass('.variant-popup-body-item');
        document.querySelectorAll('.variant-popup-body-item')[0].classList.add('active');
        handleStepCount(1);
    });
    goBackBtn.addEventListener('click', function() {
        const currentStep = parseInt(document.querySelector('.variant-popup-body-item.active').dataset.currentStep);
        console.log(currentStep)
        if(currentStep == 1){
            variantPopup.classList.remove('active');
            document.body.style.overflow = 'unset';            
        }else{
            document.querySelector('.variant-popup-body-item.active').classList.remove('active');
            if(engravingType=="Morse Code" && currentStep == 4){
                document.querySelector(`[data-current-step="${currentStep - 2}"]`).classList.add('active');
                handleStepCount(currentStep-2);
            }else{
                document.querySelector(`[data-current-step="${currentStep - 1}"]`).classList.add('active');
                handleStepCount(currentStep-1);
            }
        }
    });
    // Popup option selector
    const handwritting_popup_trigger = document.querySelector(".add-engraving-wrapper .image-wrapper")
    const variantPopupBodyItem = document.querySelectorAll('.variant-popup-body-item');
    handwritting_popup_trigger.addEventListener("click",function(){
        document.querySelector('[data-element-id="file-1"] label').click();
    })
    function removeActiveClass(selector){
        const selectorBlocks = document.querySelectorAll(selector);
        selectorBlocks.forEach(block => {
            block.classList.remove('active');
        });
    }
    function handleStepCount(currentStep, totalStep){
        document.querySelector('.variant-popup-header .current-step').innerHTML = currentStep;
        if(totalStep){
            document.querySelector('.variant-popup-header .total-steps').innerHTML = totalStep;
        }
    }
    function handleEngravingType(selector){
        const engravingTypeItemBlocks = selector.querySelectorAll('.engraving-type-item-block');
        engravingTypeItemBlocks.forEach(block => {
            block.addEventListener('click', function() {
                const currentStep = parseInt(selector.dataset.currentStep);
                engravingType = block.dataset.type;
                removeActiveClass('.engraving-type-item-block');
                block.classList.add('active');
                selector.classList.remove('active');
                document.querySelector(`[data-current-step="${currentStep + 1}"]`).classList.add('active');
                removeActiveClass('.add-engraving-input-container');
                document.querySelector(`[data-engraving-type="${engravingType}"]`).classList.add('active');
                if(engravingType=="Morse Code"){
                    document.querySelector(`.engraving-font-item-wrapper`).style.display = 'none';
                }else{
                    document.querySelector(`.engraving-font-item-wrapper`).style.display = 'block';
                }
                if(engravingType=="Coordinates"){
                    document.querySelector(`.add-engraving-wrapper .image-wrapper`).style.display = 'none';
                }else{
                    document.querySelector(`.add-engraving-wrapper .image-wrapper`).style.display = 'block';
                }
                handleStepCount(currentStep + 1,3);
            });
        });
    }
    function handleAddEngraving(selector){
        const addEngravingButton = selector.querySelector('.add-engraving-next-btn button');
        addEngravingButton.addEventListener('click', function() {
            const hasFile = document.getElementById('file-1').dataset.hasFile;
            console.log("hasFile", hasFile);
            if(!hasFile){
                alert("Please upload an image to continue");
                return false;
            }
            const currentStep = parseInt(selector.dataset.currentStep);
            engravingText = selector.querySelector('input').value;
            selector.classList.remove('active');
            document.querySelector(`[data-current-step="${currentStep + 1}"]`).classList.add('active');
            handleStepCount(currentStep + 1);
        });
    }
    function handleSelectEngravingFont(selector){
        const engravingFontItemBlocks = selector.querySelectorAll('.engraving-font-item-block');
        engravingFontItemBlocks.forEach(block => {
            block.addEventListener('click', function() {
                const currentStep = parseInt(selector.dataset.currentStep);
                engravingFont = block.dataset.font;
                removeActiveClass('.engraving-font-item-block');
                block.classList.add('active');
            });
        });
    }
    function handleAddToCart(){
        console.log("parentVariantId", parentVariantId);
        let variantId = parentVariantId;
        let formData = {'items': []};
        let data = {
            quantity: 1,
            id: variantId,
            properties: {
                "Select engraving type:": engravingType,
            }
        }
        // const fileInput = document.querySelector('#file-upload-input');
        const hasFile = document.getElementById('file-1').dataset.hasFile;
        if(!hasFile){
            alert("Please upload an image to continue");
            return false;
        }
        const fileValue = document.querySelector(".gpo-f-card a").getAttribute("href")
        if(fileValue.length > 0){
            data.properties["YOUR PICTURE"] = fileValue;
        }
        formData.items.push(data);
        const premiumGiftBox = document.querySelector('.select-product-finish-wrapper .product-option-block.active').dataset.value;
        if(premiumGiftBox == "YES"){
            let giftBoxVariantId = "39488092078141";
            let giftBoxData = {
                quantity: 1,
                id: giftBoxVariantId,
            }
            formData.items.push(giftBoxData);
        }
        console.log("formData", formData);
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        }).then(response => response.json())
        .then(data => {
            console.log(data);
            document.dispatchEvent(new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  quantity: 1,
                },
            }));
            variantPopup.classList.remove('active');
            document.body.style.overflow = 'unset';
            removeActiveClass('.variant-popup-body-item');
            document.querySelectorAll('.variant-popup-body-item')[0].classList.add('active');
        }).catch(error => {
            console.error('Error:', error);
        });
    }
    function fetchVariantDetails(variantTitle){
        const variantSelector = document.querySelector(`.hidden-variant-item[data-variant-title="${variantTitle}"]`) || null;
        if(!variantSelector){
            document.querySelector('.select-stone-add-btn button').textContent = 'Unavailable';
            document.querySelector('.select-stone-add-btn button').setAttribute('disabled', true);
            return false;
        }
        const variantId = variantSelector.dataset.variantId;
        const variantAvailable = variantSelector.dataset.variantAvailable;
        const variantPrice = variantSelector.dataset.variantPrice;
        // console.log("variantPrice", variantPrice, variantAvailable, variantId);
        parentVariantId = variantId;
        if(variantAvailable == 'true'){
            document.querySelector('.select-stone-add-btn button').innerHTML = 'Add to cart -&nbsp;' + variantPrice;
            document.querySelector('.select-stone-add-btn button').removeAttribute('disabled');
        }else{
            document.querySelector('.select-stone-add-btn button').textContent = 'Sold Out';
            document.querySelector('.select-stone-add-btn button').setAttribute('disabled', true);
        }
    }
    function handleVariantChange(){
        const selectedFinish = document.querySelector('body.custUIDesign .SizeSwatch__Radio:checked').value;
        console.log("selectedFinish", selectedFinish);
        fetchVariantDetails(selectedFinish);
    } 
    function handleSelectStone(selector){
        // Custom Cuff variant change
        const stoneItemBlocks = selector.querySelectorAll('.select-stone-block');
        const addToCartButton = selector.querySelector('.select-stone-add-btn button');
        stoneItemBlocks.forEach(block => {
            block.addEventListener('click', function() {
                removeActiveClass('.select-stone-block');
                block.classList.add('active');
                handleVariantChange();
            });
        });
        // 2x Product variant change
        const finishItemBlocks = selector.querySelectorAll('.select-finish-block');
        finishItemBlocks.forEach(block => {
            block.addEventListener('click', function() {
                block.closest('.select-product-finish-wrapper').querySelectorAll('.select-finish-block').forEach(block => {
                    block.classList.remove('active');
                });
                block.classList.add('active');
                handleVariantChange();
            });
        });
        addToCartButton.addEventListener('click', function() {
            handleAddToCart();
        });
    }
    variantPopupBodyItem.forEach(item => {
        var currentDataType = item.dataset.type;
        if(currentDataType == 'add-engraving'){
            handleAddEngraving(item);
            handleSelectEngravingFont(item);
        }
        if(currentDataType == 'select-stone'){
            handleSelectStone(item);
        }
    });
});